import React from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import Link from 'redux-first-router-link';
import selectAnalytics from './selectAnalytics';
import ExternalVideo from '../Product/ExternalVideo';
import Price from '../Product/Price';
import LazyImage from '../../hocs/Lazy/LazyImage';
import { addToBag } from '../../actions/checkout';
import { searchInput } from '../../actions/environment';
import { imageSizeTranslation } from '../../utils/image';
import { translate, translateObjectData, prefix } from '../../utils/locale';
import { urlifyAllowAccents } from '../../utils/string';
import s from './ProductItem.scss';

const emptyArray = [];

const ProductItem = ({ variantClasses = emptyArray, content, setup, currentPath, currentHash, currentView, canonical, searchInputText, itemIndex = 1, productCollectionSwatches, ...props }) => {
	content = translateObjectData(setup, content);
	const path = canonical ? translate(setup, content, 'canonicalUri') : `${currentPath}/${content.uri}${currentHash}`;
	const relatedSwatches = {};
	let productItemClasses = [s.productItem];
	if (variantClasses) productItemClasses = [...productItemClasses, ...(Array.isArray(variantClasses) ? variantClasses.filter((c) => !!c && c.indexOf('productItem') !== -1).map((c) => s[c]) : [s[variantClasses.toString()]])];
	let imageWidth = variantClasses.filter((className) => className && className.indexOf('productItem__perRow') !== -1);
	if (imageWidth.length > 0) imageWidth = Math.ceil(12 / parseInt(imageWidth[0].slice(-1), 10));
	else imageWidth = '3';

	if (content.relatedVariants && productCollectionSwatches) {
		content.relatedVariants.forEach((productKey) => {
			if (!productKey || !productCollectionSwatches[productKey]) return;
			Object.keys(productCollectionSwatches[productKey]).forEach((v) => {
				if (!relatedSwatches[v]) relatedSwatches[v] = productCollectionSwatches[productKey][v];
			});
		});
	}

	const clearSearch = () => {
		if (searchInputText !== '') props.searchInput('');
		// Clear queue in listing to get all batched impressions.
		selectAnalytics([content], setup, currentView, itemIndex);
	};

	return (
		<div className={productItemClasses.join(' ')}>
			<Link className={s.productItem_link} to={prefix(setup, path)} onClick={clearSearch}>
				<div className={s.productItem_images}>
					{
						content.media.length > 0 && content.media.map((item) => {
							if (!item || !item.src) return null;
							return (
								<figure key={item.src} className={s.productItem_image}>
									{ item.type === 'IMAGE' && <LazyImage {...imageSizeTranslation(imageWidth, item, '_')} /> }
									{ item.type === 'EXTERNAL_VIDEO' && <ExternalVideo url={item.src} uid={urlifyAllowAccents(item.alt)} itemProp="thumbnail" /> }
								</figure>
							);
						})
					}
				</div>
				<div className={[s.productItem_text, !content.inStock ? s.productItem_text__soldOut : null].join(' ')}>
					<span className={s.productItem_text_name}>{ content.name }</span>
					{ content?.variations && <span className={s.productItem_text_variant}>{ Object.keys(content.variations).map((v) => content.variations[v]).join(', ') }</span> }
					<div className={s.productItem_text_swatches}>
						{
							Object.keys(relatedSwatches).length > 0 && Object.keys(relatedSwatches).sort((a, b) => (relatedSwatches[a].order > relatedSwatches[b].order ? 1 : -1)).slice(0, 6).map((swatch, i) => {
								if (i > 5) return <div key={relatedSwatches[swatch].key} className={[s.productItem_text_swatch, s.productItem_text_swatch__more].join(' ')} />;
								return (
									<div key={relatedSwatches[swatch].key} className={s.productItem_text_swatch}>
										{ !relatedSwatches[swatch].image && relatedSwatches[swatch].color && <span style={{ backgroundColor: relatedSwatches[swatch].color }} /> }
										{ relatedSwatches[swatch].image && <LazyImage {...imageSizeTranslation('1', relatedSwatches[swatch].image, '-', true, false, 200)} /> }
									</div>
								);
							})
						}
					</div>
					{ content.more && <span className={s.productItem_text_more}>{ content.more.replace(/^'/, '') }</span> }
					<div className={s.productItem_text_price}>
						<Price price={content.price} setup={setup} soldOut={!content.inStock ? translate(setup, 'soldOut') : false} />
					</div>
				</div>
			</Link>
		</div>
	);
};

const mapState = ({ environment, productCache }, props) => ({
	setup: environment.setup,
	searchInputText: environment.searchInputText,
	productCollectionSwatches: productCache?.[environment.setup.market]?.[environment.setup.pricelist]?.productCollectionSwatches,
	...props,
});

export default hot(module)(connect(mapState, { searchInput, addToBag })(ProductItem));
